import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const MetaTags = () => {
  return (
    <>
      <title>InazumaDle - Guess Inazuma Eleven Characters Daily</title>
      <meta name="description" content="Play InazumaDle, a daily guessing game with characters from Inazuma Eleven. Guess the player with the minimum amount of tries!" />
      <meta name="keywords" content="inazuma eleven, inazumadle, football game, anime game, daily puzzle" />
      <meta property="og:title" content="InazumaDle - Guess Inazuma Eleven Characters" />
      <meta property="og:description" content="Daily game to guess Inazuma Eleven players. How many attempts will you need?" />
      <meta property="og:image" content="https://www.inazumadle.com/images/logo-social.png" />
      <meta property="og:url" content="https://www.inazumadle.com" />
      <meta name="twitter:card" content="summary_large_image" />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MetaTags /> 
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();